import {z} from 'zod';
import {emailRegex} from '../../../shared/services/emailValidation';
import {FREE_MAIL_DOMAIN_LIST} from './constants';

export const PostInquiryGeneralSchema = z.object({
  body: z.string().min(5, {message: '必須項目です'}),
  email: z.string().regex(emailRegex, 'メールアドレスの形式で入力してください'),
  name: z.string().min(1, {message: '必須項目です'}),
  subject: z.string().min(2, {message: '必須項目です'}),
});

export const PostInquiryRegisterSchema = z.object({
  body: z.string().min(5, {message: '必須項目です'}),
  email: z.string().regex(emailRegex, 'メールアドレスの形式で入力してください'),
  name: z.string().min(1, {message: '必須項目です'}),
  univ_email: z
    .string()
    .regex(emailRegex, 'メールアドレスの形式で入力してください'),
  univ_name: z.string().min(1, {message: '必須項目です'}),
});

export const PostInquiryTarekomiSchema = z.object({
  body: z.string().min(5, {message: '必須項目です'}),
  email: z
    .string()
    .regex(emailRegex, 'メールアドレスの形式で入力してください')
    .or(z.string().length(0)),
  name: z.string().min(0),
});

export const InquiryForeignUnivSchema = z.object({
  name: z.string().min(1, {message: '必須項目です'}),
  email: z
    .string()
    .regex(emailRegex, 'メールアドレスの形式で入力してください')
    .max(100, {message: '100文字以内で入力してください'}) // DB依存
    .refine(
      (value) => !FREE_MAIL_DOMAIN_LIST.includes(value.split('@')[1] ?? ''),
      'フリーアドレスは受け付けできません',
    ),
  program: z.string().min(1, {message: '必須項目です'}),
  degree: z.string().min(1, {message: '必須項目です'}),
  univ_name: z.string().min(1, {message: '必須項目です'}),
  url: z
    .string()
    .url({message: 'URLの形式で入力してください'})
    .min(1, {message: '必須項目です'}),
  country_name: z.string().min(1, {message: '必須項目です'}),
});

export const InquiryForeignUnivFormSchema = InquiryForeignUnivSchema.extend({
  degree_other: z.string(),
}).refine(
  (schema) =>
    schema.degree !== 'その他' ||
    (schema.degree === 'その他' && schema.degree_other.length > 0),
  {
    message: '「その他」を選択している場合は、必須項目です',
    path: ['degree_other'],
  },
);

export const PostInquiryForeignUnivSchema = InquiryForeignUnivSchema.extend({
  user_introduce_campaign_id: z.string().optional().nullable(),
  introducer_id: z.string().optional().nullable(),
});
